import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import { useIntl } from "react-intl";
import { StyledCustomerDashboardHeader } from "@app/customerAgent/dashboard/index.styled";
import { AddCard } from "@lib/components/MiniComponents/Others";
import AppTable from "@lib/components/MiniComponents/Table/AppTable";
import AppCard from "@lib/components/AppComponents/AppCard";
import { useEffect, useMemo, useState } from "react";
import getColumns from "@app/customerAgent/dashboard/columns";
import { useQuery } from "@tanstack/react-query";
import { apiGetTransactions } from "@lib/api/transaction";
import { TransactionType } from "@lib/types/Transaction";
import { PaymentHistoryDrawer } from "@lib/components/PageComponents/PaymentHistory";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";

export default function CustomerDashboard() {
  const { messages } = useIntl();

  const { data, refetch, isFetching, isLoading } = useQuery({
    queryKey: ["customer-dashboard-transactions"],
    queryFn: () =>
      apiGetTransactions({
        sort: "externalId,DESC",
        limit: 100,
        join: ["customer", "provider"],
      }),
    refetchInterval: 1000 * 60,
  });

  const [openDrawer, setDrawerOpen] = useState(false);
  const [selected, setSelected] = useState<TransactionType>();

  useEffect(() => {
    if (!openDrawer) setSelected(null);
  }, [openDrawer]);

  const toggle = (status?: boolean) => {
    if (typeof status !== "undefined") setDrawerOpen(status);
    else setDrawerOpen(!openDrawer);
  };

  const handleSelect = (item: TransactionType) => {
    setSelected(item);
    toggle(true);
  };

  const columns = useMemo(
    () =>
      getColumns({
        messages,
        handleSelect,
      }),
    [],
  );

  return (
    <AppsContainer
      title={messages["common.dashboard"] as string}
      fullView
      cardStyle={{
        background: "transparent",
        boxShadow: "none",
      }}
    >
      <StyledCustomerDashboardHeader>
        <AddCard
          title={messages["common.createPaymentRequest"] as string}
          onClick={toggle}
        />
      </StyledCustomerDashboardHeader>

      <AppCard
        style={{ margin: 2 }}
        title={messages["common.paymentHistory"] as string}
        extra={
          <ActionButton
            type="refresh"
            noLabel
            noBg
            size="small"
            onClick={() => refetch()}
            disabled={isFetching}
            loading={isFetching}
          />
        }
      >
        <AppTable
          rowKey={"id"}
          dataSource={data?.data?.data}
          columns={columns}
          loading={isLoading || isFetching}
          scroll={{ y: `calc(100vh - 360px)` }}
          striped
          mobileTableProps={{
            initialVisibleColumns: 5,
          }}
        />
      </AppCard>

      <PaymentHistoryDrawer
        open={openDrawer}
        toggle={toggle}
        handleSelect={handleSelect}
        selected={selected}
      />
    </AppsContainer>
  );
}
